<script lang="ts">
    import SkeletonLoader from '../SkeletonLoader.svelte';

    export let count: number = 3;
</script>

<div class="flex flex-col gap-6">
    {#each Array(count) as _, i}
        <div class="flex flex-col md:flex-row border border-gray-300 bg-white overflow-hidden h-auto md:h-[180px] rounded-lg">
            <div class="w-full md:w-2/5 h-[160px] md:h-auto">
                <SkeletonLoader class="w-full h-full" />
            </div>
            <div class="w-full md:w-3/5 p-4 md:p-5 flex flex-col gap-3">
                <SkeletonLoader class="h-6 w-3/4" />
                <SkeletonLoader class="h-4 w-1/4" />
                <SkeletonLoader class="h-12 w-full flex-1" />
                <SkeletonLoader class="h-9 w-32" />
            </div>
        </div>
    {/each}
</div>

